export default __webpack_public_path__ + "static/media/sass.b0e830ec.svg";